import apply from './apply.js';
export default function debounce(func, delay) {
  if (delay === void 0) {
    delay = 0;
  }
  var timeout;
  function debounced() {
    var _this = this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      return apply(func, _this, args);
    }, delay);
  }
  // drops a pending call
  debounced.cancel = function () {
    return clearTimeout(timeout);
  };
  return debounced;
}